import React from 'react';

/**
 * MenuErrorBoundary v7.12 — Boundary específico para páginas que consomem
 * `db.menuItems` (Cardápio Admin e Delivery do cliente).
 *
 * Por que separado do ErrorBoundary global?
 *   - Erros de formato de dados (presets como objeto, categoria desconhecida)
 *     devem mostrar fallback contextualizado pro operador entender o que
 *     fazer (recarregar, reset, ou ligar pro suporte) em vez de tela branca.
 *   - Botão "Recarregar" no fallback chama window.location.reload() para
 *     re-rodar migrations e listeners (que já normalizam dados v7.12).
 */
export default class MenuErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: null };
  }
  static getDerivedStateFromError(err) {
    return { err };
  }
  componentDidCatch(err, info) {
    // eslint-disable-next-line no-console
    console.error('[MenuErrorBoundary]', err, info?.componentStack);
  }
  render() {
    if (!this.state.err) return this.props.children;
    const msg = String(this.state.err?.message || this.state.err);
    return (
      <div data-testid="menu-error-fallback" className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
        <div className="max-w-md w-full bg-white rounded-2xl border border-amber-200 shadow-xl p-6 text-center">
          <div className="text-4xl mb-3">⚠️</div>
          <h2 className="font-bold text-lg text-slate-900 mb-2">Cardápio temporariamente indisponível</h2>
          <p className="text-sm text-slate-600 mb-4">
            Encontramos um dado em formato inesperado vindo da sincronização.
            Toque em <strong>Recarregar</strong> para baixar a versão limpa do servidor.
          </p>
          <details className="text-left mb-4">
            <summary className="text-xs text-slate-400 cursor-pointer">Detalhes técnicos</summary>
            <code className="block mt-2 p-2 bg-slate-100 rounded text-[10px] text-slate-700 break-all">
              {msg.slice(0, 300)}
            </code>
          </details>
          <button
            type="button"
            data-testid="menu-error-reload-btn"
            onClick={() => window.location.reload()}
            className="w-full px-4 py-3 rounded-xl bg-slate-900 text-white font-semibold hover:bg-slate-800 transition-all"
          >
            Recarregar
          </button>
        </div>
      </div>
    );
  }
}
